export const textTrans = {
    methods:{
        projectDisplayNoAbbr(text) {
          if(text){
            let head = text.substring(1,3);
            let body = text.substring(3,text.length-3);
            let newbody = body.replace(/[A-Z]/g,'').padStart(4,'0');
            return head + newbody;
          }else{
            return '';
          }
        },
        sampleDisplayNoAbbr(stext) {
          if(stext&&stext.indexOf('-')!==-1){
            let text = stext.split('-')[0];
            let tail = stext.split('-')[1];
          if(text){
            let head = text.substring(1,3);
            let body = text.substring(3,text.length-3);
            let newbody = body.replace(/[A-Z]/g,'').padStart(4,'0');
            return head + newbody +'-'+tail;
          }else{
            return '';
          }
        }else{
          return stext;
        }
        },
    }
}